exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-4bdc080c] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-4bdc080c] {\n  width: 100%;\n}\n.h2_title[data-v-4bdc080c] {\n  text-align: left;\n  color: grey;\n}\n", ""]);

// exports
